/**
 * Created by tschenkel on 6/29/2015.
 */

/**
 * @private
 */
export class DictionaryUtil {
    /**
     * Check whether the given dictionary contains the given key.
     *
     * @param dictionary the dictionary to check for a key
     * @param key the key to look up in the dictionary
     * @return <code>true</code> if the dictionary contains the given key, <code>false</code> if not
     */
    public static containsKey(dictionary: Map<any, any>, key: any): boolean {
        return dictionary.get(key) !== undefined;
    }
}
